import { Button } from '@foam/buoy/src/components/Button/Button';
import { Toggle } from '@foam/buoy/src/components/Toggle/Toggle';
import React from 'react';
import { FEATURE_FLAGS } from '~/constants';
import { useFeature } from '~/hooks/useFeatureFlag/useFeature';

interface MultiselectBarProps {
  isOpen: boolean;
  numberOfItems: number;
  showInShared: boolean;
  onClose: () => void;
  onClick: () => void;
  onToggle: () => void;
}

export const MultiselectBar: React.FC<MultiselectBarProps> = ({
  isOpen,
  numberOfItems,
  showInShared,
  onClose,
  onClick,
  onToggle,
}) => {
  const { isEnabled: isMediaKitsContentMetrics } = useFeature(
    FEATURE_FLAGS.foamMediaKitsContentMetrics,
  );

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-[999999] h-[60px] rounded-t-12 border-x border-t border-neutral-700 bg-neutral-900 shadow-[0_-1px_3px_0_rgba(28,33,40,0.25),0_-2px_8px_0_rgba(28,33,40,0.10)]">
      <div className="flex h-full items-center justify-center px-4">
        <div className="flex items-center gap-4 border-x border-neutral-700">
          {/* Number display */}
          <div className=" flex h-16 flex-col items-center justify-center gap-0 border-r border-neutral-700 px-4">
            <span className="text-16 font-500 text-neutral-0">
              {numberOfItems}
            </span>
            <span className="-mt-2 text-12 font-400 text-neutral-0">
              Selected
            </span>
          </div>

          {/* Toggle and text */}
          {isMediaKitsContentMetrics ? (
            <div className="flex items-center gap-2 text-neutral-0">
              <Toggle
                heading="Show metrics in shared media kit"
                labelPosition="right"
                variant="inverse"
                checked={showInShared}
                onClick={onToggle}
              />
            </div>
          ) : (
            <div />
          )}

          {/* Buttons */}
          <div className="flex gap-2 px-4">
            <Button onClick={onClose} variant="ghost-inverse" size="lg">
              Clear all
            </Button>
            <Button
              onClick={onClick}
              variant="secondary"
              size="lg"
              track-id="add-or-edit-content-to-media-kit"
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
